module.exports = __webpack_public_path__ + "static/media/shortA1ShortETest.d5a14855.mp3";